import { Validator } from '@vista-digital/validator';
import { nonEmptyStringValidator } from './string';
export const orderRedirectPaymentCreateValidator = Validator.object({
    webPaymentMethodId: Validator.number({ min: 1 }),
    redirectReturnUrl: nonEmptyStringValidator
});
